// extracted by mini-css-extract-plugin
export default {"sectionRow":"create-record_sectionRow__62jfa","contactsList":"create-record_contactsList__C2Km-"};